export default "__VITE_ASSET__44235a4b__"